import { StepIndex, FlowName } from '../types/common';
import { paymentFlowSteps } from '../constants/paymentAnalyticsConstants';

export default function getFlowStepIndex(
  flow: FlowName,
  step: string
): StepIndex {
  return paymentFlowSteps[flow]?.indexOf(step) as StepIndex;
}
